import { FormConfigContext } from '@juvare/common-form-ui/FormConfigContext';
import { defaultFormWidgets } from '@juvare/common-form-ui/WidgetForm';
import { icons } from '@juvare/common-form-ui/icons/icons';
// eslint-disable-next-line no-restricted-imports
import { defaultNotificationOptionsSettingValue } from '../../../../../../backend/config/settings/NotificationOptionsDefaultValue';
import { defaultFeatureFlags } from '../../../../../../backend/config/settings/featureFlags';
import { ContactManagementConfigContext } from '@juvare/contact-management/ui/providers';
import ContentPasteOutlinedIcon from '@mui/icons-material/ContentPasteOutlined';
import FaxOutlinedIcon from '@mui/icons-material/FaxOutlined';
import ListAltIcon from '@mui/icons-material/ListAlt';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import PhoneEnabledOutlinedIcon from '@mui/icons-material/PhoneEnabledOutlined';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import React from 'react';
import { useAlertConfig } from '../../../../../hooks';
import { buildAlertsValueProviders } from '../../../../forms/utils';
import { alertFormWidgets } from '../../../form-widgets';
import { templateIcons } from '../../AlertFab/types';
export const FormConfigContextProvider = ({ children }) => {
    var _a;
    const alertConfig = useAlertConfig();
    const { appName } = React.useContext(ContactManagementConfigContext);
    const parentFormConfig = React.useContext(FormConfigContext);
    const parentHtmlOutputIcons = (_a = parentFormConfig.globalWidgetConfig) === null || _a === void 0 ? void 0 : _a.htmlOutputIcons;
    const parentValueProviders = parentFormConfig.valueProviders;
    const formConfig = React.useMemo(() => ({
        widgets: [...defaultFormWidgets, ...alertFormWidgets],
        formParams: Object.assign(Object.assign({}, alertConfig), { features: (alertConfig === null || alertConfig === void 0 ? void 0 : alertConfig.features) ? alertConfig === null || alertConfig === void 0 ? void 0 : alertConfig.features : defaultFeatureFlags.notifications, notificationOptions: (alertConfig === null || alertConfig === void 0 ? void 0 : alertConfig.notificationOptions)
                ? alertConfig.notificationOptions
                : defaultNotificationOptionsSettingValue }),
        valueProviders: [...buildAlertsValueProviders(appName), ...(parentValueProviders !== null && parentValueProviders !== void 0 ? parentValueProviders : [])],
        globalWidgetConfig: {
            iconPickerIcons: Object.assign({}, templateIcons),
            htmlOutputIcons: Object.assign(Object.assign(Object.assign({}, parentHtmlOutputIcons), icons), { 'icon-textsms-outlined': SmsOutlinedIcon, 'icon-phone-enabled-outlined': PhoneEnabledOutlinedIcon, 'icon-fax-outlined': FaxOutlinedIcon, 'icon-email-outlined': MailOutlinedIcon, 'icon-list-alt': ListAltIcon }),
            buttonIcons: Object.assign(Object.assign({}, icons), { 'icon-clipboard-outlined': ContentPasteOutlinedIcon }),
        },
    }), [alertConfig, appName, parentValueProviders, parentHtmlOutputIcons]);
    return React.createElement(FormConfigContext.Provider, { value: formConfig }, children);
};
